import React from 'react'
import { SquareQuestionIcon } from '@shared/assets/icons'
import { countryIcons, ICON_TCP } from '@shared/config'
import { Tooltip } from '@shared/ui/organisms'

export const steamAccountCountries = [
  {
    label: 'Россия',
    icon: `${ICON_TCP}${countryIcons['Россия']}`,
  },
  {
    label: 'Казахстан',
    icon: `${ICON_TCP}${countryIcons['Казахстан']}`,
  },
  {
    label: 'Страны СНГ',
    icon: `${ICON_TCP}${countryIcons['Страны СНГ']}`,
    tooltip: (
      <Tooltip
        title="Страны СНГ"
        content="Азербайджан, Армения, Беларусь, Казахстан, Киргизия, Молдова, Таджикистан, Туркменистан, Узбекистан"
        position="top"
      >
        <SquareQuestionIcon />
      </Tooltip>
    ),
  },
]
